export default __webpack_public_path__ + "static/media/xp-arrow-right.2988d1bf.svg";